import { render, staticRenderFns } from "./SortDirection.vue?vue&type=template&id=2883e414&"
import script from "./SortDirection.vue?vue&type=script&lang=js&"
export * from "./SortDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports